export class UrpBasRequestDto {
  basId: number;
  addKbs: boolean;
}
